<div
  *ngIf="form"
  class="mb-1 flex w-full gap-2"
  [ngClass]="{
    'flex-col': direction === 'col',
    'flex-row': direction === 'row',
    'justify-center': direction === 'col',
    'items-center': direction === 'row'
  }"
>
  <label
    [class]="'relative ' + labelClass"
    [for]="name"
    [ngClass]="{
      'text-right': direction === 'row',
      'top-[-8px]': direction === 'row'
    }"
  >
    {{ label }}
  </label>
  <div class="w-full">
    <ng-container [formGroup]="form">
      <p-password
        styleClass="w-full"
        [inputStyleClass]="'min-w-[150px] ' + widthClass + ' ' + styleClass"
        [formControlName]="name"
        [id]="name"
        [required]="required"
        [toggleMask]="true"
        [feedback]="false"
        [ngClass]="
          required && name && form && form.controls[name].invalid && form.controls[name].touched
            ? 'ng-invalid ng-dirty'
            : ''
        "
      />
    </ng-container>
    <div
      *ngIf="required && name && form && form.controls[name].invalid && form.controls[name].touched"
      class="relative min-h-[1.75rem]"
    >
      <small class="p-error">
        {{ errors }}
      </small>
    </div>
  </div>
</div>
